module.exports = __webpack_public_path__ + "img/windspeed.533b9c5a.gif";